import * as z from 'zod';

export const DDLevelsSchema = z.array(z.object({ ddKey: z.string(), ddName: z.string(), ddValue: z.string().min(1, "required") }))
export const detailsSchema = z.object({
    ProjectNumber: z.number().min(0, "Project must be selected"),
    DDLevels: DDLevelsSchema,
    ap01: z.string().min(0, "Model Number must be selected"),
});

export type AdHocUnitDetailsType = z.infer<typeof detailsSchema>

export type CreateAdHocUnitItem = {
    projectNumber: number,
    disciplineId: number,
    sequenceNumber: string,
    unitNumber: string,
    modelNumber: string,
    modelFull: string,
    notSync?: boolean
}

export const createAdHocUnitDefault: CreateAdHocUnitItem = {
    disciplineId: 0,
    modelFull: "",
    modelNumber: "",
    projectNumber: 0,
    sequenceNumber: "",
    unitNumber: ""
}

export type ProjectAdHocUnitItem = {
    [projectNumber: number]: AdHocUnitItem[]
}

export type AdHocUnitItem = {
    "adhocId": number,
    "adhocUuid": string
    "completedOn": Date,
    "completedMessage": string,
    "completedStatus": string,
    "disciplineId": number,
    "extraColumn03": number,
    "extraColumn04": number,
    "extraColumn05": number,
    "modelFull": string,
    "modelNumber": string,
    "projectNumber": number,
    "requestedBy": string,
    "requestedEmail": string,
    "requestedOn": Date,
    "sequenceNumber": string,
    "unitNumber": string
}

export type ProjectAdHocItem = {
    [projectNumber: number]: AdHocItem[]
}

export type AdHocItem = {
    "adhocUuid": string,
    "projectNumber": number,
    "dd01": string | null
    "dd02": string | null
    "dd03": string | null
    "dd04": string | null
    "dd05": string | null
    "ap01": string | null
    "ap02": string | null
    "ap03": string | null
    "ap04": string | null
    "ap05": string | null
    "bp01": string | null
    "dt01": string | null
    "datetimeCreated": string
    "requestedBy": string
    "requestedEmail": string
    "datetimeCompleted": string
    "completedStatus": string
    "completedMessage": string
}